<template>
  <div
    v-if="visible"
    :style="position"
    class="epg-program js-epg-program-item"
    :class="classes"
  >
    <v-product-link
      :product="program"
      class="js-program-item"
    >
      <div
        v-for="i in repetitions"
        :key="`${program.id}-${i}`"
        :style="style"
        class="program-descritption"
      >
        <h3>{{ program.title || $t('glossary.emptyProgram') }}</h3>
        <span class="duration">
          {{ program.since | dateFormat('HH:mm') }} - {{ program.till | dateFormat('HH:mm') }}
        </span>
      </div>
    </v-product-link>
    <ui-epg-indicators
      :program="program"
      :channel="channel"
      show-live-indicator
      show-tooltip
    ></ui-epg-indicators>
    <ui-epg-lock-icon
      v-if="program.isPlaybackDisabled"
      show-tooltip
    ></ui-epg-lock-icon>
  </div>
</template>

<script>
  import { getWidth } from '@atds-legacy/dom';
  import { dateFormat, startOver } from '@/index/shared/filters';
  import VProductLink from '../../product-link/index.vue';
  import DomEvent from '../dom/dom-event';
  import UiEpgLockIcon from '../epg-lock-icon.vue';
  import UiEpgIndicators from '../epg-indicators.vue';

  export default {
    components: {
      VProductLink,
      UiEpgIndicators,
      UiEpgLockIcon,
    },
    filters: {
      startOver,
      dateFormat,
    },
    props: {
      program: undefined,
      chunk: undefined,
      dom: undefined,
      time: undefined,
      index: undefined,
      channel: undefined,
      canvasWidth: undefined,
      filter: undefined,
    },
    data() {
      return {
        visible: false,
        repetitions: 1,
      };
    },
    computed: {
      classes() {
        return {
          'epg-program--current': this.program.isCurrent,
          'epg-program--disabled': this.isDisabled,
          'epg-program--future': this.program.sinceDate > this.time.now,
          'epg-program--disallowed': this.program.isPlaybackDisabled,
        };
      },
      position() {
        const left = this.dom.dateToOffset(this.program.sinceDate);
        const right = this.dom.dateToOffset(this.program.tillDate);

        return {
          left: left + 'px',
          width: (right - left) + 'px',
        };
      },
      isDisabled() {
        return (this.filter && (!this.program.mainCategory || this.filter !== this.program.mainCategory.id)) || this.program.empty;
      },
      style() {
        return `flex-basis: ${this.canvasWidth}px`;
      },
    },
    watch: {
      visible(value) {
        if (value) {
          this.$nextTick(() => this.calculateRepetitions());
        }
      },
    },
    mounted() {
      this.calculateVisibility();
      this.dom.on(DomEvent.MOVE, this.calculateVisibility, this);
    },
    methods: {
      calculateRepetitions() {
        this.repetitions = Math.ceil(getWidth(this.$el) / this.canvasWidth);
      },
      calculateVisibility() {
        const start = this.dom.mask.start;
        const stop = this.dom.mask.stop;
        const since = this.program.sinceDate.valueOf();
        const till = this.program.tillDate.valueOf();

        this.visible = !((since < start && till < start) || (since > stop && till > stop))
          && this.index >= this.dom.mask.topIndex && this.index <= this.dom.mask.bottomIndex;
      },
    },
  };
</script>
